/*******************************************************************************
DO IF NOT EXISTS
Take action if an element does not exists and return the element so it can be chained.
*******************************************************************************/

export default function addjQueryPlugin() {
    jQuery.fn.doIfNotExists = function difNE(func) {
        if (this.length === 0) { func.apply(this); }
        return this;
    };
}
